import resume from '../assets/pdf/resume.pdf'
import myself from '../assets/pdf/myself.jpeg'
export const headerData = {
    name: 'Vaibhav Singhvi',
    title: "Web Developer",
    desciption:"Hello World! This is Vaibhav Singhvi, a tech enthusiast and a Computer Science Engineer. I believing in converting my ideas into reality with the skills I have and the knowledge I had gained. ",
    image: myself,
    resumePdf: resume
}
